// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__22j1w","signatureButtonsRight":"ModalSign_signatureButtonsRight__3DY02"};